import React from 'react';
import { ChatMessage } from '../../types/IAiConversation';
import ChatBubble from './ChatBubble';

interface IProps {
  greeting: string;
  messages: ChatMessage[];
  isThinking: boolean;
  statusText: string | null;
  canRetry: boolean;
  onRetry: () => void;
  logRef: React.RefObject<HTMLDivElement>;
  // Example questions offered while the conversation is empty.
  suggestions?: string[];
  onSuggestion?: (text: string) => void;
}

const ChatTranscript = ({
  greeting,
  messages,
  isThinking,
  statusText,
  canRetry,
  onRetry,
  logRef,
  suggestions = [],
  onSuggestion,
}: IProps) => (
  <div className="chat-log" ref={logRef} aria-live="polite">
    <div className="chat-msg chat-msg--assistant">{greeting}</div>
    {suggestions.length && onSuggestion ? (
      <div className="chat-suggestions" aria-label="Try asking">
        {suggestions.map((text) => (
          <button
            key={text}
            type="button"
            className="chat-suggestion"
            onClick={() => onSuggestion(text)}
            data-track="ai_suggestion"
          >
            {text}
          </button>
        ))}
      </div>
    ) : null}
    {messages.map((m, index) => {
      // Only the last bubble can be retried, and never while its turn is still running.
      const isLast = index === messages.length - 1;
      return (
        <ChatBubble
          key={m.id}
          message={m}
          canRetry={isLast && canRetry}
          onRetry={isLast ? onRetry : undefined}
        />
      );
    })}
    {isThinking ? (
      <div className="chat-msg chat-msg--assistant chat-msg--thinking">…</div>
    ) : null}
    {statusText ? <div className="chat-status">{statusText}</div> : null}
  </div>
);

export default ChatTranscript;
